import { render } from "./DemoAIAnalysisView.vue?vue&type=template&id=29457f20&scoped=true"
import script from "./DemoAIAnalysisView.vue?vue&type=script&lang=js"
export * from "./DemoAIAnalysisView.vue?vue&type=script&lang=js"

import "./DemoAIAnalysisView.vue?vue&type=style&index=0&id=29457f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29457f20"]])

export default __exports__